import { FC } from 'react';

const BoxIcon: FC = () => {
    return (
        <svg
            className="icon br-icon-box"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <g clip-path="url(#clip0_1123_1777)">
                <path
                    d="M2.2199 5.47198C2.09483 5.50667 1.98104 5.57357 1.8899 5.66598C1.77885 5.80152 1.71715 5.97077 1.7149 6.14598C1.2449 10.661 1.2349 13.371 1.7149 17.853C1.71514 18.0124 1.76346 18.168 1.85356 18.2995C1.94366 18.431 2.07134 18.5322 2.2199 18.59L11.7139 22.286L11.9989 22.365L12.2849 22.285L21.7789 18.591C21.9264 18.5316 22.053 18.43 22.1429 18.2989C22.2327 18.1677 22.2818 18.0129 22.2839 17.854C22.7839 13.317 22.7899 10.701 22.2839 6.20598C22.2975 6.00953 22.2348 5.81539 22.1089 5.66398C22.0259 5.54832 21.9114 5.45908 21.7789 5.40698V5.40898"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
                <path
                    d="M22.269 5.997C22.2437 5.87397 22.1888 5.75897 22.109 5.662C22.0258 5.54654 21.9113 5.45735 21.779 5.405L12.285 1.776C12.1951 1.73624 12.0978 1.7157 11.9995 1.7157C11.9012 1.7157 11.8039 1.73624 11.714 1.776L6.96698 3.623L2.21998 5.47C2.09512 5.50412 1.98135 5.57031 1.88998 5.662C1.81001 5.75926 1.75508 5.87462 1.72998 5.998C1.75592 6.12967 1.81432 6.25278 1.89988 6.35616C1.98545 6.45954 2.09548 6.53992 2.21998 6.59L11.714 10.286H12.284L17.5 8.256L21.78 6.59C21.9056 6.54105 22.0167 6.46093 22.1027 6.35718C22.1888 6.25344 22.2471 6.12948 22.272 5.997H22.27H22.269Z"
                    fill="black"
                    fill-opacity="0.12"
                />
                <path
                    d="M17.5 8.255L12.285 10.285H11.714L2.21998 6.59C2.09548 6.53992 1.98545 6.45954 1.89988 6.35616C1.81432 6.25278 1.75592 6.12967 1.72998 5.998C1.75508 5.87462 1.81001 5.75926 1.88998 5.662C1.98135 5.57031 2.09512 5.50412 2.21998 5.47L6.96698 3.623M17.5 8.255L21.78 6.59C21.9056 6.54105 22.0167 6.46093 22.1027 6.35718C22.1888 6.25344 22.2471 6.12948 22.272 5.997H22.27C22.2447 5.87397 22.1898 5.75897 22.11 5.662C22.0268 5.54654 21.9123 5.45735 21.78 5.405L12.286 1.776C12.1961 1.73624 12.0988 1.7157 12.0005 1.7157C11.9022 1.7157 11.8049 1.73624 11.715 1.776L6.96698 3.623M17.5 8.255L6.96698 3.623M12 22.365V10.285M15.5 17L19.5 15.5"
                    stroke="currentColor"
                    stroke-width="2"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_1123_1777">
                    <rect width="24" height="24" fill="white" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default BoxIcon;
